import React from 'react';
import PrimeiroAcesso from '../../../components/configuracao/primeiro-acesso'


export default function TelaConfiguração(){
    return(
        <>
            <PrimeiroAcesso />
        </>
    )
}